module.exports = __webpack_public_path__ + "img/prev-arrow-w.453efc78.svg";